<header class="page-header">
    <div>
        <h2 class="page-title">Gestión de Clientes</h2>
        <p class="page-subtitle">Visualiza y administra la cartera.</p>
    </div>
</header>

<div class="clean-card filters-container">
    <div class="filters-grid">

        <div class="filter-group">
            <label>BUSCAR CLIENTE</label>
            <div class="input-wrapper">
                <input type="text" placeholder="Nombre o ID..." (input)="onSearch($event)">
                <mat-icon>search</mat-icon>
            </div>
        </div>

        <div class="filter-group">
            <label>ESTADO</label>
            <div class="input-wrapper">
                <select>
                    <option>Cualquiera</option>
                    <option>Activo</option>
                    <option>Inactivo</option>
                </select>
                <mat-icon class="chevron">expand_more</mat-icon>
            </div>
        </div>

        <button class="btn-primary" (click)="openCreateModal()">
            <mat-icon>add</mat-icon>
            <span>Nuevo Cliente</span>
        </button>
    </div>
</div>

<div class="clean-card table-container">
    <table class="clean-table">
        <colgroup>
            <col style="width: 8%">
            <col style="width: 25%">
            <col style="width: 20%">
            <col style="width: 15%">
            <col style="width: 15%">
        </colgroup>
        <thead>
            <tr>
                <th>ID</th>
                <th>NOMBRE</th>
                <th>ESTADO</th>
                <th>CONSUMO</th>
                <th>ACCIONES</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let client of filteredClients" class="table-row">
                <td class="text-light">{{ client.id }}</td>
                <td class="font-medium">{{ client.name }}</td>
                <td>
                    <span class="badge" [ngClass]="client.status">
                        {{ client.status | uppercase }}
                    </span>
                </td>
                <td class="font-medium">{{ client.consumption | number }}</td>
                <td>
                    <div class="actions">
                        <button mat-icon-button class="icon-btn view" (click)="openModal('view', client)">
                            <mat-icon>visibility</mat-icon>
                        </button>
                        <button mat-icon-button class="icon-btn edit" (click)="openModal('edit', client)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button class="icon-btn delete" (click)="openModal('delete', client)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>

    <div class="table-footer">
        <span>Mostrando {{ filteredClients.length }} resultados</span>
    </div>
</div>

<!-- MODAL NUEVO CLIENTE -->
<div class="modal-overlay" *ngIf="modalType === 'create'" (click)="closeModal()">
    <div class="modal-card" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3 class="modal-title">Nuevo Cliente</h3>
            <button class="modal-close" (click)="closeModal()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="modal-body modal-form">
            <div class="form-field">
                <label>Nombre / Razón Social</label>
                <input type="text" placeholder="Ej: Empresa ABC S.A.C." [(ngModel)]="editForm.name">
            </div>
        </div>

        <div class="modal-footer modal-footer-actions">
            <button class="btn-ghost" (click)="closeModal()">Cancelar</button>
            <button class="btn-primary" (click)="saveCreate()">
                <mat-icon>add</mat-icon>
                Crear Cliente
            </button>
        </div>
    </div>
</div>

<!-- MODAL VER CLIENTE -->
<div class="modal-overlay" *ngIf="modalType === 'view' && selectedClient" (click)="closeModal()">
    <div class="modal-card" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3 class="modal-title">Detalles del Cliente</h3>
            <button class="modal-close" (click)="closeModal()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="modal-body modal-grid">
            <div class="view-field col-span-2">
                <label>ID Cliente</label>
                <span>{{ selectedClient.id }}</span>
            </div>
            <div class="view-field col-span-2">
                <label>Nombre / Razón Social</label>
                <span class="value-large">{{ selectedClient.name }}</span>
            </div>
            <div class="view-field col-span-2">
                <label>Estado</label>
                <span class="badge" [ngClass]="selectedClient.status">
                    {{ selectedClient.status | uppercase }}
                </span>
            </div>
        </div>

        <div class="modal-footer">
            <button class="btn-secondary" (click)="closeModal()">Cerrar</button>
        </div>
    </div>
</div>

<!-- MODAL EDITAR CLIENTE -->
<div class="modal-overlay" *ngIf="modalType === 'edit' && selectedClient" (click)="closeModal()">
    <div class="modal-card" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3 class="modal-title">Editar Cliente</h3>
            <button class="modal-close" (click)="closeModal()">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="modal-body modal-form">
            <div class="form-field">
                <label>Nombre / Razón Social</label>
                <input type="text" [(ngModel)]="editForm.name">
            </div>
            <div class="form-field">
                <label>Estado</label>
                <div class="select-wrapper">
                    <select [(ngModel)]="editForm.status">
                        <option value="active">Activo</option>
                        <option value="inactive">Inactivo</option>
                    </select>
                    <mat-icon>expand_more</mat-icon>
                </div>
            </div>
        </div>

        <div class="modal-footer modal-footer-actions">
            <button class="btn-ghost" (click)="closeModal()">Cancelar</button>
            <button class="btn-primary" (click)="saveEdit()">
                <mat-icon>save</mat-icon>
                Guardar Cambios
            </button>
        </div>
    </div>
</div>

<!-- MODAL ELIMINAR CLIENTE -->
<div class="modal-overlay" *ngIf="modalType === 'delete' && selectedClient" (click)="closeModal()">
    <div class="modal-card modal-card-sm modal-card-danger" (click)="$event.stopPropagation()">
        <div class="modal-body modal-body-center">
            <div class="danger-icon">
                <mat-icon>warning_amber</mat-icon>
            </div>
            <h3 class="modal-title">¿Eliminar Cliente?</h3>
            <p class="modal-description">
                Estás a punto de eliminar a
                <strong>{{ selectedClient.name }}</strong>.
                Esta acción no se puede deshacer.
            </p>
            <div class="modal-actions-center">
                <button class="btn-secondary" (click)="closeModal()">Cancelar</button>
                <button class="btn-danger" (click)="confirmDelete()">Sí, Eliminar</button>
            </div>
        </div>
    </div>
</div>